function supportsRequestBody(method: string): boolean {
    const normalizedMethod = method.toUpperCase();

    return normalizedMethod !== 'GET' && normalizedMethod !== 'HEAD';
}

// ----------------------------------------------------------------------------

export default supportsRequestBody;
